<template>

  <div class="app" v-if="!isOfficeMapActive"> <!-- Only render this div when not on the office map route -->
    <div class="hero hero-office" :style="{ opacity: isOfficeVisible ? 1 : 0 }"></div>
    <div class="hero hero-living" :style="{ opacity: isOfficeVisible ? 0 : 1 }"></div>
  </div>
  <div class="vacancy-map-container">

    <MapScrollytelling v-if="isMapScrollytellingVisible" />
    <router-view></router-view> <!-- Routed components will replace this area -->
  </div>

  <!-- <div class="office-map-container">
    <OfficeMapPage />
  </div> -->


</template>

<script>

import MapScrollytelling from '@/components/MapScrollytelling.vue';

// import OfficeMapPage from '@/components/OfficeMapPage.vue';


export default {
  name: 'App',
  components: {
    MapScrollytelling,
    // OfficeMapPage
  },
  data() {
    return {
      rba: 0,
      isOfficeVisible: true,
    };
  },
  mounted() {
    setInterval(() => {
      this.isOfficeVisible = !this.isOfficeVisible;
    }, 11000); // 
  },


  methods: {
    updateRba(value) {
      this.rba = value;
    },

    scrollToMap(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;

      const opacity = Math.max(0, Math.min(1, scrollY / windowHeight));

      const heroOffice = document.querySelector('.hero-office');
      const heroLiving = document.querySelector('.hero-living');

      heroOffice.style.opacity = 1 - opacity;
      heroLiving.style.opacity = opacity;
    },

  },
  computed: {
    isMapScrollytellingVisible() {
      return this.$route.path !== '/officemap'; // adjust condition based on your route setup
    },
    isOfficeMapActive() {
      return this.$route.path === '/officemap'; // Checks if the current route is /officemap
    }
  }

}
</script>


<style>
.app {
  scroll-behavior: smooth;
  position: relative;
  width: 100%;
  height: 1080px;
  overflow: hidden;

}


.hero-container {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.hero {

  height: 1080px;
  width: 100%;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 2s ease-in-out;
  overflow: hidden;
}

.hero-office,
.hero-living {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: opacity 2s ease-in-out;
}

.hero-office {
  background-image: url('~@/assets/office1.svg');
  opacity: 1;



}

.hero-living {
  background-image: url('~@/assets/living1.svg');
  opacity: 0;
}

.vacancy-map-container {
  position: relative;

  height: 1080px;
}
</style>